import { CircularProgress, Typography } from '@material-ui/core'
import { Confirm, FlexHorizontal, LoadMask, Spacer, useToasts } from '@vestaboard/installables'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'

import { Link } from '../../link'
import { TemplateCategoryForm } from '../components/TemplateCategoryForm'
import { tryAsync } from '../../../utils/tryAsync'
import { useDeleteTemplateCategory } from '../hooks/useDeleteTemplateCategory'
import { useListTemplateCategories } from '../hooks/useListTemplateCategories'
import { useUpdateTemplateCategory } from '../hooks/useUpdateTemplateCategory'

export const UpdateCategory = () => {
  const history = useHistory()
  const { addToast } = useToasts()
  const [updateTemplateCategory, { loading: saving }] = useUpdateTemplateCategory()
  const params = useParams<{ id: string }>()
  const { data, loading } = useListTemplateCategories({
    input: {}
  })
  const [isDeleting, setIsDeleting] = useState(false)
  const [deleteTemplateCategory, { loading: deleting }] = useDeleteTemplateCategory()
  const category = (data?.listTemplateCategories?.templateCategories || []).find(category => category.id === params.id)

  return (
    <>
      <Confirm
        title='Delete Template Category? This cannot be undone!'
        handleClose={() => {
          setIsDeleting(false)
        }}
        open={isDeleting}
        handleAccept={async () => {
          const { result } = await tryAsync(() =>
            deleteTemplateCategory({
              variables: {
                input: {
                  id: params.id
                }
              }
            })
          )

          if (result && result.data?.deleteTemplateCategory.__typename === 'TemplateCategoryV2') {
            history.push(`/message-templates/categories`)
          } else {
            addToast('There was an error deleting your template category', {
              appearance: 'error',
              autoDismiss: true
            })
          }
        }}
      />
      <FlexHorizontal>
        <Link to='/message-templates/categories'>
          <Typography variant='h4'>Template Categories</Typography>
        </Link>
        <Typography variant='h4'> / Update</Typography>
      </FlexHorizontal>
      <Spacer size='large' />
      {loading ? (
        <CircularProgress />
      ) : (
        <TemplateCategoryForm
          templateCategory={category}
          onDelete={() => {
            setIsDeleting(true)
          }}
          onUpdate={async templateCategory => {
            const { result } = await tryAsync(() =>
              updateTemplateCategory({
                variables: {
                  input: {
                    id: params.id,
                    title: templateCategory.title
                  }
                }
              })
            )

            if (result && result.data?.updateTemplateCategory.__typename === 'TemplateCategoryV2') {
              addToast('Template category updated.', {
                appearance: 'success'
              })
            } else {
              console.warn(result)
              addToast('There was an error saving your template category', {
                appearance: 'error'
              })
            }
          }}
        />
      )}
      {saving || deleting ? <LoadMask /> : null}
    </>
  )
}
